export default __webpack_public_path__ + "static/img_work_approach@2x-15f54b0796ef80116dc96e35ce65092c.png";